import React from 'react';
import { useFormContext } from 'react-hook-form';
import { useTranslation } from 'react-i18next';
import { EventFieldTypeProps } from './EventFieldSwitcher';

const EventFieldTypeDate: React.FC<EventFieldTypeProps> = ({
  inputName,
  field: { label, mandatory },
  disabled,
}) => {
  const { t } = useTranslation();
  const {
    register,
    formState: { errors },
  } = useFormContext();
  return (
    <div>
      <label
        className={`label-input p3-semibold ${mandatory ? 'mandatory' : ''}`}
      >
        {label}
      </label>
      <input
        className={`standard-input w-full ${
          errors[inputName]?.message && 'error'
        }`}
        type="date"
        {...register(inputName, {
          required: {
            value: mandatory,
            message: 'requiredField',
          },
        })}
        readOnly={disabled}
      />
      {errors[inputName]?.message && (
        <p className="standard-input-error">
          {t(`inputErrors.${errors[inputName]?.message}`)}
        </p>
      )}
    </div>
  );
};

export default EventFieldTypeDate;
